var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#337a10",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203.4 242",
    xmlSpace: "preserve",
    stroke: "#337a10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6,90h78V33.1h-78V90z M111.1,39v42.3L99.7,63.7l-17.8,9.5L66.6,42L46,82.4V39H111.1z M92.3,49.1c0-3.9,3.2-7.1,7.1-7.1 s7.1,3.2,7.1,7.1c0,3.9-3.2,7.1-7.1,7.1C95.5,56.2,92.3,53,92.3,49.1z M202.8,141.7l-19.1-48.3c0,0-2-20-3.8-27.7 C171.9,31.3,133.5,0,91.8,0C41.1,0,0,41.1,0,91.9c0,29.3,13.7,55.4,35.1,72.2V242h98v-28.1h14.4c20,0,36.2-16.2,36.2-36.2V152H196 c4.1,0,7.4-3.3,7.4-7.4C203.4,143.5,203.2,142.6,202.8,141.7z M78,101.3c-49.9,0-46.2,42.3-46.2,42.3C19.3,129.5,11.6,111,11.6,90.7 c0-43.9,35.6-79.4,79.4-79.4c22.9,0,43.4,9.7,57.9,25.1C148.9,36.4,149.8,99.7,78,101.3z M161.1,111.7c-5.7,0-10.3-4.6-10.3-10.3 c0-5.6,4.6-10.2,10.3-10.2c5.6,0,10.2,4.6,10.2,10.2C171.3,107.1,166.7,111.7,161.1,111.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisual);
export default __webpack_public_path__ + "static/media/visual.e18a8f007dbb65b60a6222c2a28f3b70.svg";
export { ForwardRef as ReactComponent };